import React, { useEffect, useState } from "react";

type OptionType = {
  label: string;
  value: string | number;
  lat?: number; // Optional latitude for map integration
  lng?: number; // Optional longitude for map integration
};

interface ToggleSelectorProps {
  options: OptionType[];
  onSelect?: (selected: OptionType) => void;
  defaultSelected?: OptionType;
}

const ToggleSelector: React.FC<ToggleSelectorProps> = ({
  options,
  onSelect,
  defaultSelected,
}) => {
  const [selected, setSelected] = useState<OptionType | null>(
    defaultSelected || options[0]
  );
  const handleSelect = (option: OptionType) => {
    setSelected(option);
    if (onSelect) onSelect(option);
  };

  useEffect(() => {
    if(defaultSelected){
      setSelected(defaultSelected);    
    }
  }, [defaultSelected])  

  return (
    <div className="d-block d-lg-flex">
      <div className="border border-off-white p-8px radius-8px d-flex flex-column flex-lg-row gap-10">
        {options.map((option) => (
          <button
            key={option.value}
            onClick={() => handleSelect(option)}
            className={`btn-theme max-h-30px ${
              selected?.value === option?.value
                ? "bg-teal text-black"
                : "bg-white text-grey-medium"
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ToggleSelector;
